import { useQuery } from '@hooks/reactQuery';

import { getProjectWorkflows } from '@api/projectManagement';

import { workflowsOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { ORGANISATION_PROJECTS_WORKFLOWS } from '@constants/queryKeys';

interface IUseQueryProjectWorkflowsReturned {
	projectsWorkflows: Array<TSelectOption>;
	isLoadingProjectsWorkflows: boolean;
}

export const useQueryPlatformOwnerProjectWorkflows = (): IUseQueryProjectWorkflowsReturned => {
	const {
		data: projectsWorkflows,
		isLoading: isLoadingProjectsWorkflows,
		isFetching: isFetchingProjectsWorkflows,
	} = useQuery({
		queryKey: [ORGANISATION_PROJECTS_WORKFLOWS],
		queryFn: getProjectWorkflows,
		select: requestTypes => workflowsOptionsFormatted(requestTypes),
		...refetchOptions,
	});

	return {
		projectsWorkflows: projectsWorkflows || [],
		isLoadingProjectsWorkflows: isLoadingProjectsWorkflows || isFetchingProjectsWorkflows,
	};
};
